module.exports = __webpack_public_path__ + "static/img/ls13.a26ac44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls13.png
// module id = 5Ufc
// module chunks = 12